export const TitleColumnName = 'title' as const;
export const LicensorColumnName = 'licensor' as const;
export const NameColumnName = 'name' as const;
export const TitleIdsColumnName = 'titleIds' as const;
